import React, { useState } from "react";
import CustomInput from "../CustomInput";
import SlateEditor from "../slateEditor/SlateEditor";
import Notification from "../ui-elements/Notification";
import {
  createBlog,
  deleteBlogImage,
  updateBlog,
  uploadBlogImage,
} from "../../services/blogs";
import { IS_LOCAL_ENV } from "../../App";

const BlogForm = ({ prevData, handleClose, loadToParent }) => {
  const [imgFile, setImgFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [formData, setFormData] = useState({
    title: prevData?.title || "",
    description: prevData?.description || "",
    content: prevData?.content || "",
  });

  const onChangeSomeValue = (newVal, field, subfield) => {
    let temp = { ...formData };
    if (subfield) temp[field][subfield] = newVal;
    else temp[field] = newVal;
    setFormData(temp);
  };

  const handleContentChange = (data) => {
    console.log("data", data);
    setFormData((prev) => ({ ...prev, content: data }));
  };

  const handleFileChange = (e, type) => {
    const selectedFile = e.target.files[0]; // Obtén el primer archivo seleccionado
    if (selectedFile) {
      // Verifica si el archivo es un PDF
      if (selectedFile.type.startsWith("image/") && type == "image") {
        setImgFile(selectedFile);
      } else {
        Notification({
          title: "Operación inválida",
          text: "Por favor selecciona una imagen.",
          type: "Error",
        });
      }
    }
  };

  const validateForm = () => {
    let result =
      formData.title.trim() != "" &&
      formData.description.trim() != "" &&
      formData.content.trim() != "";
    if (!prevData) result = result && imgFile != null;
    return result;
  };

  const handleSubmit = (e) => {
    setUploading(true);
    e.preventDefault();
    if (!validateForm()) {
      Notification({
        title: "Operación inválida",
        text: "Datos incompletos",
        type: "Error",
      });
      setUploading(false);
      return;
    } else {
      const uploadData = async () => {
        try {
          let newImgId = null;
          if (imgFile != null) {
            //eliminar imagen anterior en caso exista
            if (prevData) await deleteBlogImage(prevData.image.id);
            //cargar nueva imagenes
            const resim = await uploadBlogImage({
              alt: imgFile.name,
              file: imgFile,
            });
            newImgId = resim.id;
          }
          if (newImgId != null) formData.image = newImgId;

          //Preparar los datos a enviar

          console.log("data a enviar", formData);
          let response = {};

          if (prevData) {
            response = await updateBlog(prevData.id, formData);
            IS_LOCAL_ENV && console.log("response", response.doc);
          } else {
            response = await createBlog(formData);
            IS_LOCAL_ENV && console.log("response", response.doc);
          }

          Notification({
            title: "Operación completada",
            text: `Se ${prevData ? "actualizó" : "creó"} el blog con éxito`,
            type: "Success",
          });
          if (prevData) loadToParent(response.doc, prevData.id);
          else loadToParent(response.doc);
          setUploading(false);
          handleClose();
        } catch (err) {
          IS_LOCAL_ENV && console.error(err);
          Notification({
            title: "Error",
            text: `Algo salió mal...`,
            type: "Error",
          });
          setUploading(false);
        }
      };
      uploadData();
    }
  };

  return (
    <div className="flex flex-col items-center justify-center w-full h-full gap-1">
      <h3 className="text-dark-green text-xl font-bold font-poppins">
        {prevData ? "Editar" : "Crear"} Artículo
      </h3>
      <form className="flex flex-col items-center justify-center w-full h-full gap-1">
        <CustomInput
          //customMaxW={"max-w-[300px]"}
          title="Título del artículo"
          value={formData.title}
          onChange={(e) => onChangeSomeValue(e.target.value, "title")}
          placeholder="ej: Cuidados Esenciales para tu Orquídea"
          inputType="text"
          required={true}
        />
        <CustomInput
          //customMaxW={"max-w-[400px]"}
          title="Descripción"
          value={formData.description}
          onChange={(e) => onChangeSomeValue(e.target.value, "description")}
          placeholder="some description..."
          inputType="textarea"
          required={true}
        />
        <div className="w-full resize-none p-2">
          <SlateEditor
            prevValue={
              formData.content ? JSON.stringify(formData.content) : null
            }
            editable={true}
            customMaxW={"max-w-[480px]"}
            onChangeData={handleContentChange}
            title="Contenido"
            required={true}
          />
        </div>
        {/*imagen*/}
        <div className="my-2  px-4 w-full">
          <span className="font-poppins font-bold">
            {prevData ? "Reemplazar imagen" : "Cargar imagen *"}{" "}
          </span>
          <input
            className="font-poppins rounded-full text-nowrap border-accent-green border-[1px] flex flex-col w-full max-w-[300px] text-sm"
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange(e, "image")}
          />
        </div>
        <button
          className="flex px-4 py-2 m-2 rounded-full text-lg text-white bg-light-purple-600 hover:bg-dark-purple transition-all duration-100 font-poppins"
          onClick={handleSubmit}
          disabled={uploading}
          type="submit"
        >
          {prevData ? "Actualizar" : "Crear"}
        </button>
      </form>
    </div>
  );
};

export default BlogForm;
